import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../components/Cookie.jsx";

function Protected({ User }) {
  const navigate = useNavigate();

  useEffect(() => {
    const token = getCookie("sqa_token");

    if (!token) {
      navigate("/auth/user-info");
    }
  }, [navigate]);

  return <User />;
}
export default Protected;
